import { doc, updateDoc } from "firebase/firestore";
import { useState } from 'react';
import { db } from "../firebaseConfig/FirebaseConfig";

const useUpdateCount = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateCount = async (userId, field) => {
        setLoading(true);
        setError(null);
        try {
            const userDocRef = doc(db, "users", userId);
            await updateDoc(userDocRef, {
                [field]: 0
            });
            console.log(`${field} updated successfully!`);
        } catch (error) {
            setError(`Error updating ${field}: ${error.message}`);
            console.error(`Error updating ${field}: `, error);
        } finally {
            setLoading(false);
        }
    };

    return { updateCount, loading, error };
};

export default useUpdateCount;